import events from '@/services/events';


async function initializeOrderAtTable({ dispatch, rootState }) {
  const { merchantLocationId } = rootState.session.route;

  try {
    if (!merchantLocationId) {
      const fullPageMessagePayload = {
        title: 'Oops!',
        subtitle: 'A valid location is not selected.',
        description: 'Please try rescanning your QR code or ask the waitstaff for assistance.'
      };

      events.emit('full-page-message', fullPageMessagePayload);
    }
    else {
      await dispatch('session/load', {}, { root: true });

      const normalizeDetailsPayload = {
        defaultFulfillmentType: 'dine-in',
        defaultOrderType: 'table',
        orderTypes: ['table']
      };

      await dispatch('orders/normalizeOrderDetails', normalizeDetailsPayload, { root: true });

      await dispatch('socket/initialize', {}, { root: true });

      await dispatch('locations/getLocationConditionally', { withMenu: true }, { root: true });

      await dispatch('getTableOrder');
    }
  }
  catch (error) {
    throw error;
  }
}

export { initializeOrderAtTable };

